import script from "./ViewApprovalAuthoritiesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewApprovalAuthoritiesPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewApprovalAuthoritiesPage.vue?vue&type=style&index=0&id=121cb320&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121cb320"]])

export default __exports__